import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import OrdenesLista from './pages/OrdenesLista';
import OrdenNueva from './pages/OrdenNueva';
import OrdenEditar from './pages/OrdenEditar';
import OrdenDetalle from './pages/OrdenDetalle';
import Clientes from './pages/Clientes';
import Empleados from './pages/Empleados';
import Reportes from './pages/Reportes';
import Sucursales from './pages/Sucursales';
import CotizacionesLista from './pages/CotizacionesLista';
import CotizacionNueva from './pages/CotizacionNueva';
import CotizacionDetalle from './pages/CotizacionDetalle';
import Recibos from './pages/Recibos';
import ReciboDetalle from './pages/ReciboDetalle';
import './styles/App.css';

// Componente para rutas protegidas
const ProtectedRoute = ({ children, allowedRoles = [] }) => {
  const { isAuthenticated, loading, user } = useAuth();

  if (loading) {
    return (
      <div className="loading-screen">
        <img
          src="https://intersecom.com/wp-content/uploads/2021/04/cropped-logo-intersecom.png"
          alt="Intersecom"
        />
        <div className="spinner"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Verificar roles si se especificaron
  if (allowedRoles.length > 0 && !allowedRoles.includes(user?.rol)) {
    return <Navigate to="/" replace />;
  }

  return children;
};

// Componente para ruta de login (redirige si ya está autenticado)
const LoginRoute = () => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="loading-screen">
        <img
          src="https://intersecom.com/wp-content/uploads/2021/04/cropped-logo-intersecom.png"
          alt="Intersecom"
        />
        <div className="spinner"></div>
      </div>
    );
  }

  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return <Login />;
};

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginRoute />} />

      {/* Rutas protegidas dentro del Layout */}
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout>
              <Dashboard />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/ordenes"
        element={
          <ProtectedRoute>
            <Layout>
              <OrdenesLista />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/ordenes/nueva"
        element={
          <ProtectedRoute allowedRoles={['admin', 'recepcionista']}>
            <Layout>
              <OrdenNueva />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/ordenes/editar/:id"
        element={
          <ProtectedRoute>
            <Layout>
              <OrdenEditar />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/ordenes/:id"
        element={
          <ProtectedRoute>
            <Layout>
              <OrdenDetalle />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/clientes"
        element={
          <ProtectedRoute allowedRoles={['admin', 'recepcionista']}>
            <Layout>
              <Clientes />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/empleados"
        element={
          <ProtectedRoute allowedRoles={['admin']}>
            <Layout>
              <Empleados />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/reportes"
        element={
          <ProtectedRoute allowedRoles={['admin']}>
            <Layout>
              <Reportes />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/sucursales"
        element={
          <ProtectedRoute allowedRoles={['admin']}>
            <Layout>
              <Sucursales />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/cotizaciones"
        element={
          <ProtectedRoute allowedRoles={['admin', 'recepcionista']}>
            <Layout>
              <CotizacionesLista />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/cotizaciones/nueva"
        element={
          <ProtectedRoute allowedRoles={['admin', 'recepcionista']}>
            <Layout>
              <CotizacionNueva />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/cotizaciones/editar/:id"
        element={
          <ProtectedRoute allowedRoles={['admin', 'recepcionista']}>
            <Layout>
              <CotizacionNueva />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/cotizaciones/:id"
        element={
          <ProtectedRoute allowedRoles={['admin', 'recepcionista']}>
            <Layout>
              <CotizacionDetalle />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/recibos"
        element={
          <ProtectedRoute allowedRoles={['admin', 'recepcionista']}>
            <Layout>
              <Recibos />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/recibos/:id"
        element={
          <ProtectedRoute allowedRoles={['admin', 'recepcionista']}>
            <Layout>
              <ReciboDetalle />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppRoutes />
    </AuthProvider>
  );
}

export default App;
